var _rect, _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivation90Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#F7F6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7074 35.4993L31.7044 35.0607C31.7997 35.8732 32.0553 36.4769 32.4601 36.8652C32.8659 37.2592 33.4063 37.4534 34.0723 37.4534C34.9188 37.4534 35.6352 37.0594 36.2261 36.2771C36.8169 35.4949 37.1925 33.87 37.3585 31.4116C36.3214 32.6079 35.0298 33.206 33.4725 33.206C31.7851 33.206 30.322 32.5576 29.0954 31.2564C27.8689 29.9552 27.2578 28.2657 27.2578 26.1822C27.2578 24.0987 27.9036 22.2596 29.2008 20.9327C30.498 19.6014 32.1506 18.9385 34.1542 18.9385C36.3326 18.9385 38.1253 19.781 39.5223 21.4605C40.9193 23.1456 41.6212 25.9121 41.6212 29.77C41.6212 33.6279 40.8946 36.5193 39.4427 38.2535C37.9908 39.9933 36.0971 40.8604 33.764 40.8604C32.0867 40.8604 30.7346 40.4118 29.6975 39.5145C28.666 38.6218 28 37.2815 27.7096 35.4971L27.7074 35.4993Z",
    stroke: "#187C85",
    strokeWidth: 0.917525,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9921 26.5171C36.9921 25.1958 36.6871 24.1691 36.0761 23.4415C35.4706 22.7139 34.7643 22.3501 33.9627 22.3501C33.161 22.3501 32.5702 22.6492 32.0701 23.2473C31.5645 23.8455 31.3145 24.8219 31.3145 26.1778C31.3145 27.5337 31.5903 28.5705 32.1363 29.2188C32.6823 29.8616 33.3628 30.1864 34.1847 30.1864C35.0065 30.1864 35.6422 29.8772 36.1826 29.2545C36.723 28.6318 36.9943 27.719 36.9943 26.5182L36.9921 26.5171Z",
    stroke: "#187C85",
    strokeWidth: 0.917525,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_11572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1155 19.3975C52.1211 19.3975 53.6885 20.1164 54.8219 21.5531C56.1669 23.25 56.8426 26.0706 56.8426 30.0051C56.8426 33.9397 56.1626 36.7603 54.8079 38.4766C53.6842 39.8939 52.1222 40.6031 50.1166 40.6031C48.111 40.6031 46.4767 39.827 45.2419 38.2747C44.0081 36.7225 43.3906 33.9494 43.3906 29.9674C43.3906 25.9853 44.0696 23.2403 45.4243 21.524C46.548 20.1067 48.1099 19.3975 50.1155 19.3975Z",
    stroke: "#187C85",
    strokeWidth: 0.917525,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1153 22.6949C49.6425 22.6949 49.2183 22.8493 48.8523 23.158C48.481 23.4613 48.1917 24.0118 47.9888 24.8074C47.7189 25.8339 47.584 27.5697 47.584 30.0049C47.584 32.4401 47.7049 34.1176 47.9456 35.0286C48.1863 35.9397 48.4907 36.5474 48.8566 36.8507C49.2226 37.154 49.6425 37.3041 50.1153 37.3041C50.5881 37.3041 51.0123 37.1497 51.3836 36.841C51.7495 36.5377 52.0388 35.9872 52.2418 35.1916C52.5116 34.1748 52.6466 32.4434 52.6466 30.0038C52.6466 27.5643 52.5257 25.8955 52.285 24.9844C52.0442 24.0734 51.7398 23.4613 51.3739 23.1569C51.008 22.8482 50.5881 22.6938 50.1153 22.6938V22.6949Z",
    stroke: "#187C85",
    strokeWidth: 0.917525,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_11572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3706,
    height: 22.1232,
    fill: "white",
    transform: "translate(42.9316 18.9385)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivation90Icon);
export default __webpack_public_path__ + "static/media/activation90-icon.82db054d433a7a06db4be92cf5d6aa54.svg";
export { ForwardRef as ReactComponent };